<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup></script>

<style lang="less">
* {
  box-sizing: border-box;
  :focus-visible {
    outline: -webkit-focus-ring-color auto 0px;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: #f5f7fa;
}
table {
  border-collapse: collapse;
}
.flex {
  display: flex;
}
.juc {
  justify-content: center;
}
.jul {
  justify-content: left;
}
.jusb {
  justify-content: space-between;
}
.jusa {
  justify-content: space-around;
}
.aic {
  align-items: center;
}
.flex1 {
  flex: 1;
}
.w100 {
  width: 100%;
}
.h100 {
  height: 100%;
}
.wh100 {
  width: 100%;
  height: 100%;
}
.fs12 {
  font-size: 12px;
}
.fs14 {
  font-size: 14px;
}
.fs16 {
  font-size: 16px;
}
.fwb {
  font-weight: bold;
}
.mb10 {
  margin-bottom: 10px;
}
#print {
  color: #000000 !important;
}
.card-container .el-card__body {
  width: 100%;
  height: 100%;
  box-sizing: border-box !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: none !important;
}
// 全局移除表格中操作按钮的悬停和焦点边框，防止闪烁
.el-table {
  .el-button.is-link {
    // 默认状态就移除边框
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    // 禁用边框相关的过渡动画
    transition: none !important;
    border-color: transparent !important;

    &:hover,
    &:focus,
    &:focus-visible,
    &:active,
    &:visited {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      border-color: transparent !important;
    }
  }

  .el-dropdown {
    .el-button.is-link {
      // 默认状态就移除边框
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      // 禁用边框相关的过渡动画
      transition: none !important;
      border-color: transparent !important;

      &:hover,
      &:focus,
      &:focus-visible,
      &:active,
      &:visited {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        border-color: transparent !important;
      }
    }
  }
}
* :focus-visible {
  outline: none;
}
</style>
